import CheckerPendingAssignmentView from "./CheckerPendingAssignmentView";

export default function CheckerPendingTeamView() {
  return (
    <CheckerPendingAssignmentView
      title="Pending with Team"
      intro="Review invoices currently sitting with your teams and reassign them to available processors using the existing Django team-routing flow."
      endpoint="/api/get-pendingInvoices-team/"
      legacySection="teamspending"
      legacyButtonLabel="Open Legacy Team Queue"
      loadingLabel="Loading team pending invoices…"
      emptyLabel="No invoices found in the pending-with-team queue."
      queueLabel="team pending"
      queueNote="Invoices currently pending with a team and available for reassignment."
      unassignedNote="Rows that still do not have a processor selected in the team queue."
    />
  );
}
